/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Flex, Spacer, Text } from "@nordcloud/gnui";
import styles from "~/assets/styles/Runbook.module.css";
import { FlexContainer } from "~/components";
import { Customer } from "~/components/BasicCustomerInfo/types";
import { DetailsTitle } from "~/components/Styled/Common";
import { Divider } from "~/components/Styled/Divider";

type Props = {
  customer: Customer;
};

function CustomerDetails({ customer }: Props) {
  const jiraServicePortalLinks = customer?.info?.links?.filter(
    (link) => link?.desc === "Jira Service Portal Link"
  );
  const managedEscalationLinks = customer?.info?.links?.filter(
    (link) => link?.desc === "Managed Escalation Include"
  );

  return (
    <Divider>
      <Spacer height="1rem" />
      <Text isTitle weight="medium">
        Customer Details
      </Text>

      <FlexContainer direction="column" align="flex-start">
        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Customer name
          </DetailsTitle>
          <Text tag="span" className={styles.propertyValue}>
            {customer.name}
          </Text>
        </Flex>
        <Spacer height="0.2rem" />

        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Salesforce Account ID
          </DetailsTitle>
          <Text tag="span" className={styles.propertyValue}>
            {customer.info?.salesforceId}
          </Text>
        </Flex>
        <Spacer height="0.2rem" />

        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Jira Service Portal Link
          </DetailsTitle>
          {jiraServicePortalLinks?.map((j, index) => (
            <div key={index}>
              <Text
                tag="span"
                className={index ? styles.url : styles.propertyValue}
              >
                {index ? ", " : ""}
              </Text>
              <a key={j?.name} href={j.url} target="_blank" rel="noreferrer">
                {j.url}
              </a>
            </div>
          ))}
        </Flex>

        <Spacer height="0.2rem" />
        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Raise Alarm Email
          </DetailsTitle>
          <Text tag="span" className={styles.propertyValue}>
            {customer?.info.raiseAlarmEmail || "-"}
          </Text>
        </Flex>

        <Spacer height="0.2rem" />
        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Service Request Email
          </DetailsTitle>
          <Text tag="span" className={styles.propertyValue}>
            {customer.info.serviceRequestEmail || "-"}
          </Text>
        </Flex>
        <Spacer height="0.2rem" />

        <Flex>
          <DetailsTitle className={styles.propertyLabel}>
            Management Escalation include
          </DetailsTitle>
          {managedEscalationLinks?.map((m, index) => (
            <div key={index}>
              <Text
                tag="span"
                className={index ? styles.url : styles.propertyValue}
              >
                {index ? ", " : ""}
              </Text>
              <a key={m?.name} href={m.url} target="_blank" rel="noreferrer">
                {m.url}
              </a>
            </div>
          ))}
        </Flex>
      </FlexContainer>

      <Spacer height="1rem" />
    </Divider>
  );
}

export { CustomerDetails };
